import ProgramTemplate from './ProgramTemplate';

export default ProgramTemplate;
